var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.7934282,32.0445143 C23.1543928,31.4054807 22.1183118,31.4054807 21.4792765,32.0445143 C20.8402412,32.6835478 20.8402412,33.7196259 21.4792765,34.3586595 L25.6413031,38.5206744 C26.355344,39.2347134 27.5393537,39.1379458 28.1279778,38.3174418 L38.6931223,23.590312 C39.219915,22.8559969 39.0516832,21.8336682 38.3173661,21.3068769 C37.5830489,20.7800856 36.5607173,20.9483169 36.0339245,21.682632 L26.5924125,34.8434908 L23.7934282,32.0445143 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "select/option/selected",
    transform: "translate(-336.000000, -21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/checkmark",
    transform: "translate(315.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/30x30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u21B3-bg",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stroke-756",
    fill: "#4B89DC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "attribute/color/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.582e74fc.svg";
export { ForwardRef as ReactComponent };